import { stripAnsi } from '@cli-utils/text.js'

/** `\r` counts as a line break because the Vercel CLI redraws its spinners with carriage returns. */
export function createFilteredLineForwarder(
  shouldShow: (line: string) => boolean,
  write: (text: string) => void
): { push(chunk: string): void; flush(): void } {
  let pending = ''

  const emit = (line: string) => {
    if (shouldShow(stripAnsi(line).trim())) write(`${line}\n`)
  }

  return {
    push(chunk: string) {
      pending += chunk
      const lines = pending.split(/\r\n|\n|\r/)
      pending = lines.pop() ?? ''
      for (const line of lines) emit(line)
    },
    flush() {
      if (pending !== '') emit(pending)
      pending = ''
    }
  }
}
